import notEmpty from './notEmptyValidator'

const isEmail = function (valueToValidate) {
    const regexResult = valueToValidate ? valueToValidate.match(/^\S+@\S+\.[a-zA-Z]+$/g) : false  
    const validationResult = !!(regexResult && regexResult.length)
    
    return notEmpty(valueToValidate) && validationResult
}

export default isEmail